module.exports = __webpack_public_path__ + "images/dbf89e2e788197920c70b426182f3ee9.svg";